module.exports = __webpack_public_path__ + "img/car.front.88168a92.png";